var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._v("Bạn đang cố gắng truy cập trang không được cấp quyền, vui lòng đăng nhập lại")])
}
var staticRenderFns = []

export { render, staticRenderFns }